export default __webpack_public_path__ + "static/media/join-us.46943a70.webp";